<template>
  <Modal
    title="报告单上传"
    width="800"
    :value="value"
    @on-visible-change="onVisibleChange"
    :mask-closable="false"
    @on-cancel="onVisibleChange(false)"
  >
    <Form
      ref="editForm"
      :model="editData"
      :rules="editRules"
      inline
      :label-width="125"
    >
      <Row>
        <Col span="24">
        <FormItem
          label="产品编码"
          prop="skuCode"
        >
          <SkuInput
            v-model="editData.skuCode"
            :name.sync="editData.skuName"
          />
  
        </FormItem>
        </Col>
      
        <Col span="12">
        <FormItem
          label="批次号"
          prop="pici"
        >
          <Input
            type="text"
            v-model="editData.pici"
            placeholder="请输入批次号"
          >
          </Input>
        </FormItem>
        </Col>
      </Row>
      <FormItem
        label="附件名称"
        prop="fujianAddr"
        style="width:100%"
      >
        <Upload
          type="drag"
          ref="uploadRefs"
          multiple
          :show-upload-list="false"
          :before-upload="onBeforeUpload"
          :on-success="onUploadSuccess"
          :on-error="onUploadError"
          :on-progress="onUploadProgress"
          action="/api/CusFahuo/uploadFahuo"
        >
          <div style="padding: 20px 0">
            <Icon
              type="ios-cloud-upload"
              size="52"
              style="color: #3399ff"
            ></Icon>
            <p>点击或文件拖拽进行上传</p>
          </div>
        </Upload>
        <div
          v-if="attachmentList.length"
          class="report-attachment-list"
        >
          <div
            v-for="(attachment,index) in attachmentList"
            :key="attachment.storedName"
            class="report-attachment-item"
          >
            <span class="report-attachment-name">{{attachment.originalName}}</span>
            <Tooltip content="移除附件">
              <Button
                type="text"
                icon="ios-close-circle-outline"
                :disabled="isUploading"
                @click="removeAttachment(index)"
              ></Button>
            </Tooltip>
          </div>
        </div>
        <p
          v-if="isUploading"
          class="report-attachment-tip"
        >附件上传中，请等待上传完成后保存。</p>
      </FormItem>
      <Row>
        <Col
          span='8'
          offset='10'
          class="btn-groups"
        >
        <Button
          type="primary"
          :loading="saving"
          :disabled="isUploading || saving"
          @click="clickSave"
        >保存</Button>
        <Button
          type="default"
          @click="clickCancel"
        >取消</Button>
        </Col>
      </Row>
    </Form>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
import CTable from '@/components/CTable'
import BtnEvent from '@/components/BtnEvent'
import {areaRule} from '@/plugin/validateRule'
import {timeFormat} from '@/plugin/tool'
import SkuInput from '@/components/SkuInput/index.vue'
import {
  normalizeReportAttachment,
  parseReportAttachments,
  stringifyReportAttachments
} from '@/plugin/reportAttachment'
export default {
  name: 'EditModal',
  mixins: [BtnEvent],
  components: {
    CTable,SkuInput
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Boolean,
    /** 父组件正在提交报告时锁定保存按钮，避免连续点击产生并发请求。 */
    saving: {
      type: Boolean,
      default: false
    }
  },
  watch: {
  },
  data () {
    return {
      attachmentList: [],
      isUploading: false,
      editData: {
        id: null,
        skuCode: null,
        skuName: '',
        pici: '',
        fujianAddr: ''
      },
      editRules: {
        id: [
          {required: false,message: 'The name cannot be empty',trigger: 'blur'}
        ],
        skuCode: [
          {required: true,message: '产品编码',trigger: 'blur'}
        ],
        skuName: [
          {required: true,message: '产品名称',trigger: 'blur'}
        ],
        pici: [
          {required: true,message: '批次号',trigger: 'blur'}
        ],
        fujianAddr: [
          {required: true,message: '附件名称',trigger: 'blur'}
        ],
      }
    }
  },
  created () {

  },
  methods: {
    setData (data) {
      this.editData=Object.assign({
        id: null,
        skuCode: null,
        skuName: '',
        pici: '',
        fujianAddr: ''
      },data)
      this.attachmentList=parseReportAttachments(this.editData.fujianAddr)
      this.syncAttachmentValue()
    },
    deleteAction (p) {
      this.$emit('on-delete',p)
    },
    onVisibleChange (value) {
      if(this.value!==value) {
        this.$emit('change',value)
      }
      if(!value) {
        this.isUploading=false
        this.$refs['uploadRefs'].clearFiles()
      }
    },
    clickCancel () {
      this.$emit('change',false)
    },
    onBeforeUpload () {
      this.isUploading=true
      return true
    },
    onUploadProgress () {
      this.isUploading=true
    },
    onUploadSuccess (res) {
      const attachment=normalizeReportAttachment(res && res.data)
      if(!res || !res.reFlag || !attachment) {
        this.$Message.error((res && res.message) || '附件上传失败')
        this.syncUploadingState()
        return
      }
      // Upload 组件可能对同一文件重复回调成功事件，按服务器存储名幂等追加。
      if(this.attachmentList.some(item => item.storedName === attachment.storedName)) {
        this.syncUploadingState()
        return
      }
      this.attachmentList.push(attachment)
      this.syncAttachmentValue()
      this.syncUploadingState()
    },
    onUploadError () {
      this.$Message.error('附件上传失败')
      this.syncUploadingState()
    },
    syncUploadingState () {
      this.$nextTick(() => {
        const fileList=this.$refs['uploadRefs'].fileList || []
        this.isUploading=fileList.some(file => file.status==='uploading')
      })
    },
    syncAttachmentValue () {
      this.editData.fujianAddr=this.attachmentList.length
        ? stringifyReportAttachments(this.attachmentList)
        : ''
    },
    removeAttachment (index) {
      this.$Modal.confirm({
        title: '移除附件',
        content: '<p>确定从本次报告单中移除该附件吗？服务器中的原文件不会被删除。</p>',
        onOk: () => {
          this.attachmentList.splice(index,1)
          this.syncAttachmentValue()
        }
      })
    },
    clickSave () {
      if(this.saving) {
        return
      }
      if(this.isUploading) {
        this.$Message.warning('附件正在上传，请稍后保存')
        return
      }
      this.syncAttachmentValue()
      this.$refs['editForm'].validate((valid) => {
        if(valid) {
          this.$emit('on-save',this.editData)
        } else {
          this.$Message.error('Fail!');
        }
      })
    }
  }
}
</script>
<style >
.ivu-upload {
  width: 100%;
}

.report-attachment-list {
  margin-top: 8px;
  border-top: 1px solid #e8eaec;
}

.report-attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  border-bottom: 1px solid #f2f3f5;
}

.report-attachment-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-attachment-tip {
  margin-top: 8px;
  color: #ff9900;
}
</style>
